import axios from 'axios';

const BASE_URL = 'https://api.omnirep.online';
//const BASE_URL = 'http://localhost:5000/';


const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token.replace(/"/g, '')}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle expired session globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    const token = localStorage.getItem("token");
    const currentPath = window.location.pathname;

    // If there is no token yet (app restoring state), do NOT redirect
    if (!token) {
      return Promise.reject(error);
    }

    // Avoid redirect loops on the login routes
    if (currentPath.startsWith("/auth")) {
      return Promise.reject(error);
    }

    // Handle real unauthorized case
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/auth/sign-in?reason=expired";
      return;
    }

    return Promise.reject(error);
  } 
);

export default axiosInstance;
